module.exports = __webpack_public_path__ + "static/media/upload.5a99dc2a.svg";